import BigNumber from 'bignumber.js'

type TBNArg = string | number | BigNumber

export function compoundPeriodInterests(
  deposit: TBNArg,
  apy: TBNArg,
  daysInYear: TBNArg,
  payoutDays: TBNArg,
  isTotal = true,
): string {
  const percent = new BigNumber(apy).dividedBy(100).plus(1).toNumber()

  const exponent = new BigNumber(1).dividedBy(daysInYear).toNumber()

  const estimatedTotal = new BigNumber(percent ** exponent).pow(payoutDays).multipliedBy(deposit)

  if (isTotal) {
    return estimatedTotal.toString()
  } else {
    return estimatedTotal.minus(deposit).toString()
  }
}
